import React from 'react';
import PropTypes from 'prop-types';
import Amount from 'sharedWebpack/Amount';
import getTripType from '../../../../IBE/lib/helpers/getTripType';
import getDestinationByTripType from '../../../../IBE/lib/helpers/getDestinationByTripType';
import JourneySummaryIndicator from '../../../../JourneySummaryIndicator';
import './styles.scss';

const RouteInfoWithPrice = ({ trips, currency, grossAmount, supplierReservationIdentifier }) => {
  const tripType = getTripType(trips);
  const originCode = trips[0]?.originCode;
  const destinations = trips.map(({ destinationCode }) => destinationCode);
  const destinationCode = getDestinationByTripType(tripType, destinations);
  const allAirports = trips.flatMap(({ airports }) => airports);
  const originCountryInfo = allAirports.find(airport => airport.code === originCode);
  const destinationCountryInfo = allAirports.find(airport => airport.code === destinationCode);

  return (
    <div className="d-flex align-center justify-between route-info-with-price">
      <div className="d-flex align-center column-gap-12">
        <JourneySummaryIndicator
          trips={trips}
          originCountryInfo={originCountryInfo}
          destinationCountryInfo={destinationCountryInfo}
        />
        {supplierReservationIdentifier && (
          <span className="route-info-with-price__identifier">
            {I18n.t(
              'admin.components.orders.items_tab.placeholder.reservation_id.airline_reservation_id',
              {
                id: supplierReservationIdentifier,
              },
            )}
          </span>
        )}
      </div>
      <Amount className="route-info-with-price__amount" currency={currency} value={grossAmount} />
    </div>
  );
};

RouteInfoWithPrice.defaultProps = {
  supplierReservationIdentifier: '',
};

RouteInfoWithPrice.propTypes = {
  trips: PropTypes.arrayOf(
    PropTypes.shape({ originCode: PropTypes.string, destinationCode: PropTypes.string }),
  ).isRequired,
  currency: PropTypes.string.isRequired,
  grossAmount: PropTypes.string.isRequired,
  supplierReservationIdentifier: PropTypes.string,
};

export default RouteInfoWithPrice;
